/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Import_Link_PlaceholderInputs */

const en_import_link_placeholder = /** @type {(inputs: Import_Link_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a link: video, website …`)
};

const de_import_link_placeholder = /** @type {(inputs: Import_Link_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link einfügen: Video, Website …`)
};

/**
* | output |
* | --- |
* | "Paste a link: video, website …" |
*
* @param {Import_Link_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const import_link_placeholder = /** @type {((inputs?: Import_Link_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Import_Link_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_import_link_placeholder(inputs)
	return en_import_link_placeholder(inputs)
});